export default {"src":"/_next/static/media/purple-right.67a0d0e8.svg","height":280,"width":1920,"blurWidth":0,"blurHeight":0};